import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { FormEventRegistrationService } from 'src/app/service/form-event-registration.service';
import { LoadingService } from 'src/app/service/loading.service';
import { FormApplicantService } from "../../../service/form-applicant.service";
import { WrapperType } from "../../../interfaces/form-model";

@Component({
  selector: 'app-registrant-wrapper',
  templateUrl: './registrant-wrapper.component.html',
  styleUrls: ['./registrant-wrapper.component.scss']
})
export class RegistrantWrapperComponent extends FieldWrapper {

  modalOpen: boolean = false;

  constructor(
    private loadingService: LoadingService,
    private formEventRegistrationService: FormEventRegistrationService,
    private formApplicantService: FormApplicantService
  ) {
    super();
  }

  wrapperType(): WrapperType {
    const wrapper = this.props['wrapperType'] as WrapperType;
    if (wrapper) {
      return wrapper;
    }
    return WrapperType.REGISTRANT;
  }

  showCancelButton(): boolean {
    return this.wrapperType() === WrapperType.REGISTRANT;
  }

  registeredUserName(): string {
    return this.props['firstName'] + " " + this.props['lastName'];
  }

  private get refreshCallback(): Function {
    return this.props['refreshCallback'] as Function;
  }

  registeredUserType(): string {
    if (!this.props['guest'] && !this.props['self']) {
      return this.wrapperType() === WrapperType.APPLICANT ? "" : "(Linked)";
    } else if (this.props['guest']) {
      return "(Guest)";
    } else {
      return "(Self)";
    }
  }

  onRefreshClick(event: MouseEvent): boolean {
    event.stopPropagation();

    this.loadingService.setLoading(true);

    this.formEventRegistrationService
      .refreshRegistrant(this.props['uuId'], this.props['sectionId'], this.props['id'])
      .subscribe({
        next: () => {
          this.refreshCallback();
        },
        error: () => {
          this.loadingService.setLoading(false);
        }
      });

    return false;
  }

  onCancelClick(event: MouseEvent): boolean {
    event.stopPropagation();

    this.modalOpen = true;

    return false;
  }

  onOpenDrawer(): void {
    this.formEventRegistrationService
      .toggleShow(this.props['uuId'], this.props['sectionId'], this.props['id'])
      .subscribe();
  }

  onCloseDrawer(): void {
    this.formEventRegistrationService
      .toggleHide(this.props['uuId'], this.props['sectionId'], this.props['id'])
      .subscribe();
  }

  onClose(): void {
    this.modalOpen = false;
  }

  onRemove(): void {
    switch (this.wrapperType()) {
      case WrapperType.REGISTRANT:
        this.onRemoveRegistrant();
        break;
      case WrapperType.APPLICANT:
        this.onRemoveApplicant();
        break;
    }
  }

  onDeleteClick(event: MouseEvent) {
    event.stopPropagation();

    this.modalOpen = true;

    return false;
  }

  onLinkClick(event: MouseEvent) {
    event.stopPropagation();
    this.modalOpen = false;
    this.onLinkApplicant();
    return false;
  }

  onUnlinkClick(event: MouseEvent) {
    event.stopPropagation();
    this.modalOpen = false;
    this.onRemoveApplicant();
    return false;
  }

  private onRemoveRegistrant(): void {
    this.loadingService.setLoading(true);
    this.formEventRegistrationService
      .removeRegistrant(this.props['uuId'], this.props['sectionId'], this.props['id'])
      .subscribe({
        next: () => {
          this.refreshCallback();
        },
        error: () => {
          this.loadingService.setLoading(false);
        }
      })
  }

  private onLinkApplicant() {
    this.loadingService.setLoading(true);
    this.formApplicantService.linkApplicant(this.props['uuId'], this.props['id'])
      .subscribe({
        next: () => {
          this.refreshCallback();
        },
        error: () => {
          this.loadingService.setLoading(false);
        }
      });
  }

  private onRemoveApplicant() {
    this.loadingService.setLoading(true);
    this.formApplicantService.deleteApplicant(this.props['uuId'], this.props['id'])
      .subscribe(() => {
        this.refreshCallback();
      });
  }
}
